<div class="wrapper">
    <!-- start .row -->
    <div class="row">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="./assets/global/images/cabeceras/bg_admin_auditoria.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración</h1>
        </div>
    </div>
    <!-- end .row -->
    <div class="container-fluid">
        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Administración</a></li>
                            <li class="breadcrumb-item"><a href="#">Paramétricas</a></li>
                            <li class="breadcrumb-item"><a href="#">Documentos Siniestros</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Administración Paramétricas</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->
        <div class="col-lg-12">
            <div class="card-box">
                <h4 class="header-title mb-3">Registro documentación por solicitar al cliente durante la radicación del siniestro.</h4>
                <form [formGroup]="forSinAmp">
                    <div class="form-row ">
                        <div class="form-group col-md-6">
                            <label>Ramo<span class="text-danger">*</span></label>
                            <ng-select2 formControlName="ramo" id="ramo"
                                (valueChanged)="refreshListByramo($event)" [data]="listBouquet" class="form-control">
                            </ng-select2>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Nombre documento<span class="text-danger">*</span></label>
                            <input type="text" formControlName="nombre" class="form-control">
                        </div>
                        <div class="actions clearfix">
                            <button type="button" *ngIf="!edit" (click)="onSubmitAmp()"
                                class="btn btn-custom waves-effect waves-light">
                                <i class="fi-plus"></i>Agregar documento
                            </button>
                            <button type="button" *ngIf="edit" (click)="updateAmparo()"
                                class="btn btn-custom waves-effect waves-light">
                                <i class="fi-plus"></i>Editar documento
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-lg-12" *ngIf="addDocumentFlag">
            <div class="card-box">
                <h4 class="header-title mb-3">Registro de Documentos</h4>
                <form [formGroup]="formDocSin">
                    <div class="form-row ">
                        <div class="form-group col-md-6">
                            <label>Nombre documento<span class="text-danger">*</span></label>
                            <input type="text" formControlName="nombreAmparo" class="form-control" readonly>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Nombre documento (visible para el usuario)<span class="text-danger">*</span></label>
                            <input type="text" formControlName="nombre" class="form-control">
                        </div>
                        <div class="actions clearfix">
                            <button type="button" *ngIf="!editDocumentFlag" (click)="onSubmitDoc()"
                                class="btn btn-custom waves-effect waves-light">
                                <i class="fi-plus"></i>Agregar Documento
                            </button>
                            <button type="button" *ngIf="editDocumentFlag" (click)="updateDocument()"
                                class="btn btn-custom waves-effect waves-light">
                                <i class="fi-plus"></i>Editar Documento
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card-box table-responsive">
                    <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                        <div class="row">
                            <div class="col-sm-12">
                                <div style="position: absolute; height: 1px; width: 0px; overflow: hidden;"><input
                                        type="text" tabindex="0"></div>
                                <table class="table table-hover m-0 tickets-list table-actions-bar dt-responsive nowrap"
                                    cellspacing="0" width="100%" id="datatableAmp">
                                    <thead>
                                        <tr>
                                            <th>Ver Documentos</th>
                                            <th>Nombre Amparo</th>
                                            <th>Modificar</th>
                                            <th>Eliminar</th>
                                            <th>Agregar Documento</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of ListAmparosByRamo">
                                            <td><a (click)="ListarDocumentos(item.idAdmAmparo,item.nombre)"
                                                    class="btn btn-sm btn-info"><i class="mdi mdi-eye-outline"></i></a>
                                            </td>
                                            <td>{{item.nombre}}</td>
                                            <td><a (click)="editAmparo(item.nombre,item.idAdmAmparo)"
                                                    class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>
                                            </td>
                                            <td><a (click)="deleteAmparo(item.idAdmAmparo)"
                                                    class="btn btn-sm btn-danger"><i class="mdi mdi-delete"></i></a>
                                            </td>
                                            <td><a (click)="addDocument(item.idAdmAmparo,item.nombre)"
                                                    class="btn btn-sm btn-success"><i class="mdi mdi-plus"></i></a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row" *ngIf="tablaDocumentos">
            <div class="col-12">
                <div class="card-box table-responsive">
                    <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                        <div class="row">
                            <div class="col-sm-12">
                                <div style="position: absolute; height: 1px; width: 0px; overflow: hidden;"><input
                                        type="text" tabindex="0"></div>
                                <table class="table table-hover m-0 tickets-list table-actions-bar dt-responsive nowrap"
                                    cellspacing="0" width="100%" id="datatableDoc">
                                    <thead>
                                        <tr>
                                            <th>Descripción Documentos</th>
                                            <th>Modificar</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngIf="!ListDocuments">
                                            <td>No existen registros asociados</td>
                                        </tr>
                                        <tr *ngFor="let item of ListDocuments">
                                            <td>{{item.nombre}}</td>
                                            <td><a (click)="editDocumentoAmparo(item.nombre,item.idAdmAmparoDocumento)"
                                                    class="btn btn-sm btn-purple"><i class="mdi mdi-pencil"></i></a>
                                            </td>
                                            <td><a (click)="deleteDocumentoAmparo(item.idAdmAmparoDocumento)"
                                                    class="btn btn-sm btn-danger"><i class="mdi mdi-delete"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div> <!-- end container -->
</div>
<!-- end wrapper -->
<div class="blanco"></div>